import { render, staticRenderFns } from "./ProvinceView.vue?vue&type=template&id=036d7375&"
import script from "./ProvinceView.vue?vue&type=script&lang=js&"
export * from "./ProvinceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports